import React, { useState } from "react"
import { useSearchParams } from "react-router-dom"
import Step1 from "./Step1"
import Step2 from "./Step2"
import { parseQuerystring } from "../../../Code/Utilities"



function Steps({ onSuccess, userId }) {
  const [step, setStep] = useState(0)
  const [searchParams, setSearchParams] = useSearchParams()
  const { RC, RCAE, CHARITYID } = parseQuerystring(window.location.search.toUpperCase())
  const STEPS = [Step1, Step2]
  const [codeAsEntered, _setCodeAsEntered] = useState(RCAE || RC || '');

  // Mirror codeAsEntered into the URL (?RC=...) so that if the parent decides
  // to swap to the regular RedeemCodes flow (test code / no custom branding),
  // the new component initialises its code from the URL rather than starting
  // empty.
  const setCodeAsEntered = (val) => {
    _setCodeAsEntered(val)
    const next = new URLSearchParams(searchParams)
    if (val) next.set("RC", val)
    else next.delete("RC")
    setSearchParams(next, { replace: true })
  }

  const handleContinue = () => {
    setStep(step + 1)
  }

  const handleBack = () => {
    setStep(step - 1)
  }

  const StepComponent = STEPS[step]

  return <StepComponent
    onContinue={handleContinue}
    onBack={handleBack}
    codeAsEntered={codeAsEntered}
    charityId={CHARITYID}
    userId={userId}
    setCodeAsEntered={setCodeAsEntered}
    onSuccess={onSuccess} />
}

export default Steps
